import React from 'react';

const Icon = ({ size = '40', fill = '#17EE65', ...other }) => {
    return (
        <svg width={size} height={size} viewBox="0 0 40 40" fill="none" {...other}>
            <path
                d="M19.5 4C26.404 4 32 9.524 32 16.338c0 3.316-1.333 6.426-3.66 8.725a12.533 12.533 0 0 1-3.373 2.374v1.25c0 .614-.247 1.202-.687 1.636a2.36 2.36 0 0 1-1.657.677h-6.246a2.359 2.359 0 0 1-1.657-.678 2.298 2.298 0 0 1-.686-1.635v-1.25a12.476 12.476 0 0 1-6.085-6.376A12.161 12.161 0 0 1 7 16.338C7 9.524 12.596 4 19.5 4Zm1.573 3.182a.762.762 0 0 0 .085.584.78.78 0 0 0 .478.353 8.652 8.652 0 0 1 3.576 1.882 8.504 8.504 0 0 1 2.31 3.287.78.78 0 0 0 1.01.441.777.777 0 0 0 .433-.406.76.76 0 0 0 .015-.59 10.045 10.045 0 0 0-2.73-3.886 10.221 10.221 0 0 0-4.227-2.222.79.79 0 0 0-.592.084.772.772 0 0 0-.358.473ZM14.786 33h9.428c.524 0 .786.333.786 1s-.262 1-.786 1h-9.428c-.524 0-.786-.333-.786-1s.262-1 .786-1Z"
                fill={fill}
            />
        </svg>
    );
};
export default React.memo(Icon);
